import Contents from "./contents";
import type { StepType } from "@reactour/tour";
import TourStepContent from "./wrapper";
import { text } from "@quickpoint.me/shared";
import { fireClearCodeEvent } from "../../../editor/events";
import { typeSomeText } from "../../common";
import { switchToLevel } from "../ai-first/helpers";

const intro: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.fullWelcome}
						<br />
						<br />
						{/* same opening as the Quick Start tour — the AI belongs here too */}
						{text.tourSteps.welcomeDescription}
						<br />
						<br />
						{text.tourSteps.fullWelcomeInstructions}
					</span>
				)}
			/>
		),
		position: "center",
		action: () => {
			switchToLevel(3);
			fireClearCodeEvent();
			typeSomeText({ text: " " });
		},
	},
	{
		selector: ".tour",
		content: () => (
			<TourStepContent description={() => text.tourSteps.fullRevisitGuide} />
		),
	},
	{
		selector: "window",
		content: Contents,
		position: "center",
	},
];

export default intro;
